import { IAnonymousStudentService } from '@studyportals/anonymous-student-interfaces';
import { StudentField, IStudent } from '@studyportals/studentdomain';

export class StudentClient {
	constructor(private client: IAnonymousStudentService) {}

	public async getData(fields: StudentField[]): Promise<IStudent | null> {
		try {
			return await this.client.getStudentData(fields);
		} catch {
			return null;
		}
	}

	public async getCompleteness(fields: StudentField[]): Promise<number> {
		try {
			return await this.client.getStudentDataCompleteness(fields);
		} catch {
			return 0;
		}
	}
}
